/*
 * CmdK/GlobalSearch Messages
 *
 * This contains all the text for the GlobalSearch component.
 */

import { defineMessages } from 'react-intl'

export const scope = 'app.components.CmdKGlobalSearch'

export default defineMessages({
	header: {
		id: `${scope}.header`,
		defaultMessage: 'This is the CmdKGlobalSearch component!',
	},
})
